<template>
    <div class="vertical-container vertical-container--in-secondary-content">
        <div class="vertical-container__header vertical-container__header--has-shadow">
            <div class="container">
                <div class="section-header">
                    <div class="section-header__title">
                        <h1>Dispozice</h1>
                    </div>

                    <div class="section-header__button">
                        <custom-button @click="create" primaryadd>
                            <span icon>&plus;</span>
                            <span class="section-header__button-label">Založit novou dispozici</span>
                        </custom-button>
                    </div>
                </div>
            </div>
        </div>

        <div class="vertical-container__content">
            <elementary-section>
                <div class="container">
                    <info-block>
                        <p class="info__text">
                            Domovio má již vydefinované nejčastější dispozice. Pokud zde není vámi požadovaná, můžete si
                            jí
                            jednodušše založit níže.
                        </p>
                        <p class="info__text">
                            Předdefinované dispozice:
                            <template v-for="(disposition, index) in systemDispositions">
                                <template v-if="index !== 0">,</template>
                                <strong>{{ disposition.title }}</strong>
                            </template>
                        </p>
                    </info-block>

                    <disposition-container/>
                </div>
            </elementary-section>
        </div>
    </div>
</template>

<script>
import InfoBlock from '@/components/Block/InfoBlock';
import ElementarySection from '@/components/Content/ElementarySection';
import DispositionContainer
    from '@/modules/ProjectModule/modules/OptionModule/components/Disposition/DispositionContainer';
import CreateDispositionDialog
    from '@/modules/ProjectModule/modules/OptionModule/components/Disposition/CreateDispositionDialog';
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    name:       'ProjectOptionDispositionView',
    components: {CustomButton, DispositionContainer, ElementarySection, InfoBlock},
    computed:   {
        systemDispositions() {
            return this.$store.getters['projects/project/systemDispositions'];
        }
    },
    methods:    {
        create() {
            this.$modal.show(CreateDispositionDialog, {}, defaultModalParameters());
        }
    }
}
</script>
